import { Component,ChangeDetectorRef,NgZone, HostListener } from '@angular/core';
import { AngularDelegate, Platform } from '@ionic/angular/lazy';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
//import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import {TranslateService} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../environments/environment';
import { Router,NavigationStart } from '@angular/router';
import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { APIService } from './API.service';
import { AlertController } from '@ionic/angular/lazy';
import { MenuController } from '@ionic/angular/lazy';
//import { Plugins } from '@capacitor/core';
import {AnalyticsService} from './service/analytics.service';
import { DataTransferService } from './service/data-transfer.service';
//const { Geolocation } = Plugins;
import { ElementRef } from '@angular/core';
import { ConsoleExperience } from 'amazon-quicksight-embedding-sdk';
import { IonicstorageService } from './CareGiver/service/ionicstorage.service';
import { AmplifyConfigService } from './amplify-config.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  emailValue: string | undefined;
  timeOut: ReturnType<typeof setTimeout> | undefined;
  currentUrl: string="";
  isMobileApp=environment.isMobileApp;
  activeUrl: string="";
  userLogin:Boolean=false;
  userPoolId: string | undefined;
  tabMenuShow:Boolean=false;
  userType:String="";
  constructor(
    private platform: Platform,
    //private splashScreen: SplashScreen,
    //private statusBar: StatusBar,
    private translate: TranslateService,
    private http: HttpClient,
    private ref: ChangeDetectorRef,
    private router:Router,
    private ngZone:NgZone,
    private apiService: APIService,
    public alertController: AlertController,
    public menuCtrl: MenuController,
    public analytics: AnalyticsService,
    private dataTransfer:DataTransferService,
    private elementRef:ElementRef<HTMLElement>,
    private ionicstorageService: IonicstorageService,
    private amplifyConfigService: AmplifyConfigService
  ) {
    var poolName = localStorage.userPool;
    if(poolName){
      var userPool = environment.userPool.find(x => x.domain === poolName);
      this.userPoolId = userPool?.aws_user_pools_id;
      console.log(this.userPoolId);
      var userPoolClientId = userPool?.aws_user_pools_web_client_id? userPool.aws_user_pools_web_client_id : '';
      var identityPoolId = userPool?.aws_cognito_identity_pool_id? userPool.aws_cognito_identity_pool_id : '';
      //Amplify.configure(userPool); 
      // Amplify.configure({
      //   Auth: {
      //     Cognito: {
      //       userPoolId: this.userPoolId,
      //       userPoolClientId: userPoolClientId,
      //       identityPoolId: identityPoolId
      //     }
      //   }
      // });
      if(this.userPoolId)
        this.amplifyConfigService.configure(this.userPoolId,userPoolClientId,identityPoolId);
    }    
    localStorage.transLang = localStorage.transLang ? localStorage.transLang : 'en';
    this.initializeApp();
    translate.setDefaultLang('en');
    translate.use('en');   
    fetchAuthSession().then(data=>{
      this.userLogin = true;
    },error=>{
      this.userLogin = false;
      setTimeout(()=>{
        var url = this.router.url?.split("?")[0];
        if(url!="/create-account" && url!="/reset-password" && url!="/accept-invite")
          this.ngZone.run(() => this.router.navigate(['/sign-in']));
      },3000);
      //this.ngZone.run(() => this.router.navigate(['/sign-in']));
    });
    router.events.subscribe((val) => {  
      if(val instanceof NavigationStart) {
        this.activeUrl = val['url'].split("?")[0]; 
        var url = val['url'].split("?");
        var userLog = {type:"pageView",userId:localStorage.currentSub,dateTime:new Date(),url:val['url']};
        this.analytics.saveUserLogs(userLog);
        if(url[0] == "/sign-in" && url.length>1){
          setTimeout(()=>{
            var orguser = url[1].split('&');
            var orguser1 = orguser[0].split('=');
            var orguser2 = orguser[1].split('=');
            var username, orgname;
            if(orguser1[0]=="uname"){
              username=orguser1[1];
              orgname = orguser2[1];
            }else{
              username=orguser2[1];
              orgname = orguser1[1];
            }
            var re = /%20/gi; 
            var neworg = orgname.replace(re, " "); 
            var userPool = environment.userPool.find(x => x.domain == neworg);
            if(userPool){
              this.userPoolId = userPool.aws_user_pools_id;
              var userPoolClientId = userPool?.aws_user_pools_web_client_id? userPool.aws_user_pools_web_client_id : '';
              var identityPoolId = userPool?.aws_cognito_identity_pool_id? userPool.aws_cognito_identity_pool_id : '';
              //Amplify.configure(userPool); 
              // Amplify.configure({
              //   Auth: {
              //     Cognito: {
              //       userPoolId: this.userPoolId,
              //       userPoolClientId: userPoolClientId,
              //       identityPoolId: identityPoolId
              //     }
              //   }
              // });
              this.amplifyConfigService.configure(this.userPoolId,userPoolClientId,identityPoolId);
              this.dataTransfer.setUser({userName:username});
              this.router.navigate(['/reset-password']);
            }
          },2000);          
        }else{
          if(!sessionStorage.isLogin){
            var currentLocation = localStorage.currentLocation;
            if(url[0]!="/create-account" && url[0] != "/sign-in" && url[0] != "/reset-password" && url[0] != "/accept-invite")
              this.signOutUser(currentLocation); 
          }
        }
      }      
    });
  }
  initializeApp() {
    this.platform.ready().then(() => {
      //this.statusBar.styleDefault();
      //this.splashScreen.hide();
      if (Capacitor.isNativePlatform()) {
        StatusBar.setStyle({ style: Style.Default });
        SplashScreen.hide();
      }      
    });
  }
  ngOnInit(){
    this.onResize();
    if(this.userPoolId)
      this.getTenantConfig(this.userPoolId);
    this.checkIdleTimeout();
    this.checkUserSession();
    this.getMapquestKey();
    this.menuUpdate();
    /*if(!sessionStorage.isLogin){
      var currentLocation = localStorage.currentLocation;
      console.log("this.router.url",this.router.url);
      //setTimeout(()=>{
        var url = this.router.url?.split("?")[0];
        if(url!="/create-account")
          this.signOutUser(currentLocation); 
      //},100);      
    }*/
    Hub.listen('auth', (data) => {
      switch (data.payload.event) {
      case 'signedIn':
        this.userLogin = true;
        var userPool = environment.userPool.find(x => x.domain === localStorage.userPool);
        var userPoolId = userPool?.aws_user_pools_id;
        console.log("userPoolId",userPool,userPoolId);
        if(userPoolId)
          this.getTenantConfig(userPoolId);
        break;
      case 'signedOut':
        this.userLogin = false;
        break;
      }
    });
  }
  async menuUpdate(){
    // getCurrentUser().then(async (user) => {
    //   const userAttributes = await fetchUserAttributes();
    //   this.userType = (userAttributes["custom:userType"] || "").toLocaleLowerCase();
    //   console.log(this.userType);
    // });
    var user = await this.dataTransfer.getAuthUser();
    console.log("user",user);
    this.userType = (user?.attributes["custom:userType"] || "").toLocaleLowerCase();
  }
  getTenantConfig(poolId: string){
    this.apiService.GetTenantConfig(poolId).then(data=>{
      const tenantConfig = data.result?.[0];
      if(tenantConfig){
        for(let item of Object.keys(tenantConfig)){
          var key: string = "--"+item;
          var value = (key.replace(/([A-Z])/g, '-$1').trim()).toLowerCase();
          const configValue = tenantConfig[item as keyof typeof tenantConfig];
          if(configValue != null)
            this.elementRef.nativeElement.style.setProperty(value, configValue);   
        }
      }
    }).catch(error=>{
      console.log(error);
    });
  }
  getMapquestKey(){
    this.apiService.GetParameterDataByName("mapquest_key").then(param=>{
      const mapquestKey = param.result?.[0]?.Value;
      if(mapquestKey != null)
        this.dataTransfer.setMapquestKey(mapquestKey);
    }).catch(error=>{
      console.log(error);
    });
  }
  federatedSignIn(){
    signInWithRedirect({ provider: { custom: 'SimbiQOpenID' } });    
  }
  checkUserSession(){
    var checkinter = setInterval(()=>{
      if(sessionStorage.isLoginGetSession){
        getCurrentUser().then(async (user) => {
          //const userAttributes = await fetchUserAttributes();
          //var sub = userAttributes["custom:subId"];
          var sub = user?.userId;
          this.apiService.GetSessionuserData("get",sub,"","loggedIn").then(data=>{
            const code = data.result?.[0]?.code;
            if(sessionStorage.isLogin && code && localStorage.userRandomToken != code){
              clearInterval(checkinter);
              this.presentAlert("You have been signed out because your account is signed in from another device");
            }
          }).catch(error=>{
            console.log(error);
          });
        }).catch(error=>{
          console.log(error);
          var currentLocation = localStorage.currentLocation;
          this.signOutUser(currentLocation);
        }); 
      }
    },5000);
  }
  async presentAlert(msg: string) {
    const alert = await this.alertController.create({
      cssClass: 'custom-alert',
      message: msg,
      buttons: [{
        text: 'OK',
        cssClass: 'alertmsg-button',
        handler: () => {
          //var currentLocation = localStorage.currentLocation;
          //this.signOutUser(currentLocation);
          //this.checkUserSession();    
        }
      }]
    });
    await alert.present();

    const { role } = await alert.onDidDismiss();
    var currentLocation = localStorage.currentLocation;
    this.signOutUser(currentLocation);
    this.checkUserSession();
  }
  signOutUser(currentLocation: string | null | undefined){
    var userMail = localStorage.userMail;
    var userPool = localStorage.userPool;
    var userLog = {type:"loggedOut",userId:localStorage.currentSub,dateTime:new Date()};
    this.analytics.saveUserLogs(userLog);
    signOut().then(res=>{
      localStorage.clear();
      sessionStorage.clear();
      if(currentLocation && currentLocation!=undefined && currentLocation!='undefined'){
        localStorage.currentLocation = currentLocation;
        localStorage.defaultLocation = currentLocation;
        localStorage.defaultViewLocation = currentLocation;
      }
      if(userMail && userPool && userMail!='undefined' && userPool!='undefined'){
        localStorage.userMail = userMail;
        localStorage.userPool = userPool;
      }      
      this.router.navigate(['/sign-in']);
    },error=>{
      localStorage.clear();
      sessionStorage.clear();
      if(currentLocation && currentLocation!=undefined && currentLocation!='undefined'){
        localStorage.currentLocation = currentLocation;
        localStorage.defaultLocation = currentLocation;
        localStorage.defaultViewLocation = currentLocation;
      }
      if(userMail && userPool && userMail!='undefined' && userPool!='undefined'){
        localStorage.userMail = userMail;
        localStorage.userPool = userPool;
      }
      this.router.navigate(['/sign-in']);
    });
  }
  checkIdleTimeout(){
    this.timeOut =  setTimeout(() => {
      console.log("Session Timeout");
      var currentLocation = localStorage.currentLocation;
      this.signOutUser(currentLocation);
    }, 900000);
  }
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    clearTimeout(this.timeOut);
    this.checkIdleTimeout();
  };
  @HostListener('document:click', ['$event'])
  onClick(e: MouseEvent) {
    clearTimeout(this.timeOut);
    this.checkIdleTimeout();
  };
  @HostListener('window:keyup', ['$event'])
  onKeyup(e: KeyboardEvent) {
    clearTimeout(this.timeOut);
    this.checkIdleTimeout();
  };
  closeMenu(){
    this.menuCtrl.close();
  }
  async signOut() {
    this.menuCtrl.close();
    var currentLocation = localStorage.currentLocation;
    await this.ionicstorageService.clear();
    this.signOutUser(currentLocation);
  }
  routeChange(){
    this.currentUrl = this.router.url;
  }
  onResize(){
    if(window.innerWidth <= 640)
      this.tabMenuShow=true;
    else
      this.tabMenuShow=false;
  }
}